
import Vue from 'vue';
import { APP_ERROR_EVENT } from '../../../../constants';
import { Core } from '../../../../services/core';
import { PackagePartEntity, PackagePartsStore } from '../../../../services/parts';

export default Vue.extend({
  name: 'partsPackagesView',
  data() {
    return {
      isMounted: false,
      isLoading: false,

      metadata: {
        package: undefined as PackagePartEntity | undefined,
      },
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Packages', route: '/parts/packages' },
    ]);
  },

  async mounted() {
    this.$set(this, 'isLoading', true);
    try {
      const [entity] = await Promise.all([PackagePartsStore.get(this.$route.params.guid)]);

      this.$set(this.metadata, 'package', entity);
    } catch (e) {
      console.error(e);
      Core.Eventhub.emit(APP_ERROR_EVENT, e);
      return;
    } finally {
      this.$set(this, 'isMounted', true);
      this.$set(this, 'isLoading', false);
    }

    this.$metronic.breadcrumbs.appendBreadcrumb({
      title: this.metadata.package?.description as string,
    });
  },
});
